export default __webpack_public_path__ + "static/media/message.5edfb62a.png";